export default "__VITE_ASSET__8edd754e__"